// src/pages/service/notificationHub.js
import * as signalR from "@microsoft/signalr";

const HUB_URL = "https://localhost:7004/hubs/notifications"; // adjust port

export const createNotificationHub = (token) => {
  console.log('🔧 Creating SignalR hub with URL:', HUB_URL);
  console.log('🔑 Token provided:', token ? 'Yes (length: ' + token.length + ')' : 'No');
  
  return new signalR.HubConnectionBuilder()
    .withUrl(HUB_URL, {
      accessTokenFactory: () => {
        console.log('🔑 Access token factory called');
        return token;
      }
    })
    .withAutomaticReconnect([0, 2000, 5000, 10000, 20000])
    .configureLogging(signalR.LogLevel.Debug) // Change to Debug for more details
    .build();
};